// Константы для WDBB Satinwood

export const STATES = [
  { value: 'AL', label: 'AL - Alabama' },
  { value: 'AK', label: 'AK - Alaska' },
  { value: 'AZ', label: 'AZ - Arizona' },
  { value: 'AR', label: 'AR - Arkansas' },
  { value: 'CA', label: 'CA - California' },
  { value: 'CO', label: 'CO - Colorado' },
  { value: 'CT', label: 'CT - Connecticut' },
  { value: 'DE', label: 'DE - Delaware' },
  { value: 'DC', label: 'DC - District of Columbia' },
  { value: 'FL', label: 'FL - Florida' },
  { value: 'GA', label: 'GA - Georgia' },
  { value: 'HI', label: 'HI - Hawaii' },
  { value: 'ID', label: 'ID - Idaho' },
  { value: 'IL', label: 'IL - Illinois' },
  { value: 'IN', label: 'IN - Indiana' },
  { value: 'IA', label: 'IA - Iowa' },
  { value: 'KS', label: 'KS - Kansas' },
  { value: 'KY', label: 'KY - Kentucky' },
  { value: 'LA', label: 'LA - Louisiana' },
  { value: 'ME', label: 'ME - Maine' },
  { value: 'MD', label: 'MD - Maryland' },
  { value: 'MA', label: 'MA - Massachusetts' },
  { value: 'MI', label: 'MI - Michigan' },
  { value: 'MN', label: 'MN - Minnesota' },
  { value: 'MS', label: 'MS - Mississippi' },
  { value: 'MO', label: 'MO - Missouri' },
  { value: 'MT', label: 'MT - Montana' },
  { value: 'NE', label: 'NE - Nebraska' },
  { value: 'NV', label: 'NV - Nevada' },
  { value: 'NH', label: 'NH - New Hampshire' },
  { value: 'NJ', label: 'NJ - New Jersey' },
  { value: 'NM', label: 'NM - New Mexico' },
  { value: 'NY', label: 'NY - New York' },
  { value: 'NC', label: 'NC - North Carolina' },
  { value: 'ND', label: 'ND - North Dakota' },
  { value: 'OH', label: 'OH - Ohio' },
  { value: 'OK', label: 'OK - Oklahoma' },
  { value: 'OR', label: 'OR - Oregon' },
  { value: 'PA', label: 'PA - Pennsylvania' },
  { value: 'RI', label: 'RI - Rhode Island' },
  { value: 'SC', label: 'SC - South Carolina' },
  { value: 'SD', label: 'SD - South Dakota' },
  { value: 'TN', label: 'TN - Tennessee' },
  { value: 'TX', label: 'TX - Texas' },
  { value: 'UT', label: 'UT - Utah' },
  { value: 'VT', label: 'VT - Vermont' },
  { value: 'VA', label: 'VA - Virginia' },
  { value: 'WA', label: 'WA - Washington' },
  { value: 'WV', label: 'WV - West Virginia' },
  { value: 'WI', label: 'WI - Wisconsin' },
  { value: 'WY', label: 'WY - Wyoming' }
];

export const CONSTRUCTION_TYPES = [
  { value: 'Fire Resistive', label: 'Fire Resistive' },
  { value: 'MNC', label: 'Modified Non-Combustible (MNC)' },
  { value: 'NC', label: 'Non-Combustible (NC)' },
  { value: 'JM', label: 'Joisted Masonry (JM)' },
  { value: 'Frame', label: 'Frame' },
  { value: 'BV', label: 'Brick Veneer (BV)' }
];

export const ROOF_TYPES = [
  { value: 'Metal', label: 'Metal' },  // -0.15
  { value: 'Slate', label: 'Slate' },  // -0.10
  { value: 'Membrane roofs (rubber)', label: 'Membrane roofs (rubber)' },  // -0.10
  { value: 'Single ply', label: 'Single ply' },  // -0.075
  { value: 'Tile', label: 'Tile' },  // -0.05
  { value: 'Membrane roofs (all other)', label: 'Membrane roofs (all other)' },  // -0.05
  { value: 'Shingle', label: 'Shingle' },  // 0.0
  { value: 'Unknown', label: 'Unknown' },  // 0.0
  { value: 'Built up Tar & Gravel', label: 'Built up Tar & Gravel' }  // +0.05
];

export const OCCUPANCY_TYPES = [
  { value: 'Hotel/Motel', label: 'Hotel/Motel' },
  { value: 'All Other', label: 'All Other' }
];

export const APPLICATION_METHODS = [
  { value: 'perBuilding', label: 'Per Building' },
  { value: 'perLocation', label: 'Per Location' },
  { value: 'perOccurrence', label: 'Per Occurrence' }
];

export const DEDUCTIBLE_TYPES = [
  { value: 'percent', label: 'Percentage' },
  { value: 'percentWithMin', label: 'Percentage with Minimum' },
  { value: 'flat', label: 'Flat Dollar' }
];